import { GlobalAxios } from "../axios/axios-config";
import {
  IEsignRuleGroup,
  IUpdateEsignRuleGroup,
} from "../models/esign-rule-group";

const ROUTE = process.env.REACT_APP_4UESIGN + "/api/v1/ESignRuleGroup/";

export const getEsignRuleGroupById = (id: string) =>
  GlobalAxios.get<IEsignRuleGroup>(ROUTE + id);

export const updateEsignRuleGroup = ({
  item,
  id,
}: {
  item: IUpdateEsignRuleGroup;
  id: string;
}) => GlobalAxios.put(ROUTE + id, item);
